export const de = {
    common: {
        home: 'Startseite',
        search: 'Suchen',
        guest: 'Gast',
        logout: 'Abmelden',
        toggleTheme: 'Theme umschalten',
        toggleSidebar: 'Seitenleiste umschalten',
        close: 'Schließen',
        more: 'Mehr',
        saveChanges: 'Änderungen speichern',
        cancel: 'Abbrechen',
        delete: 'Löschen',
        export: 'Exportieren',
        loading: 'Wird geladen...',
        activity: 'Aktivität',
        confirm: 'Bestätigen',
        noResultsFound: 'Keine Ergebnisse gefunden.',
        justNow: 'gerade eben',
        minutesAgo: 'vor {{count}} Min.',
        hoursAgo: 'vor {{count}} Std.',
        daysAgo: 'vor {{count}} Tg.',
        pagination: {
            previous: 'Zurück',
            next: 'Weiter',
            page: 'Seite {{page}} von {{totalPages}}',
            summary: 'Seite {{page}} von {{totalPages}} · {{count}} von {{total}} Einträgen angezeigt'
        }
    },
    notFound: {
        title: '404',
        heading: 'Seite nicht gefunden',
        description: 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
        cta: 'Zu Organisationen'
    },
    routeError: {
        heading: 'Etwas ist schiefgelaufen',
        description: 'Beim Laden dieser Seite ist im Router ein unerwarteter Fehler aufgetreten.',
        cta: 'Zurück zum Dashboard'
    },
    startup: {
        preparingSessionTitle: 'Sitzung wird vorbereitet',
        preparingSessionDescription: 'Wir prüfen die Authentifizierung, bevor die App interaktiv wird.',
        preparingSessionStatus: 'Authentifizierung wird geprüft',
        loadingDataTitle: 'Startdaten werden geladen',
        loadingDataDescription: 'Die erforderlichen Konto- und Organisationsdaten für die App werden geladen.',
        loadingDataStatus: 'Startdaten werden geladen',
        waitHint:
            'Diese Ansicht bleibt sichtbar, bis der Start vollständig abgeschlossen ist, damit geschützte Navigation nicht zu früh eingeblendet wird.',
        errorTitle: 'Der Start konnte nicht abgeschlossen werden',
        errorDescription:
            'Eine wiederherstellbare Startanfrage ist fehlgeschlagen. Versuche es erneut, ohne die ganze Seite neu zu laden.',
        errorFallback: 'Unerwarteter Startfehler.',
        retry: 'Start erneut versuchen',
        retryHint: 'Falls das Problem bestehen bleibt, prüfe die Backend-Verbindung und den Authentifizierungsstatus.'
    },
    appShell: {
        onboardingCheck: {
            failureTitle: 'Onboarding konnte noch nicht geprüft werden',
            failureDescription:
                'Aktionen bleiben pausiert, während wir die Onboarding-Prüfung der Organisation erneut ausführen.',
            retry: 'Onboarding-Prüfung erneut versuchen'
        }
    },
    dashboardWelcome: {
        badge: 'Willkommen im Dashboard beim ersten Start',
        title: 'Du bist drin. Hier ist dein Scaffold nach dem Checkout.',
        description:
            'FE-seitig gemockter Dashboard-Zustand für neue Organisationen. Echte API-Key-Erstellung, Starter-Templates und Live-Konsolenausgaben kommen später.',
        continueAction: 'Weiter zur Organisation',
        apiKeyTitle: 'API-Key-Scaffold',
        apiKeyDescription:
            'Platzhalterkarte für den ersten Projektschlüssel, Scopes, Kopieraktion und Metadaten zur letzten Nutzung.',
        primaryKey: 'Primärschlüssel',
        createApiKey: 'API-Key erstellen',
        quickstartTitle: 'Quickstart-Scaffold',
        quickstartDescription:
            'Der Standard-Tab folgt dem Build-Modus aus dem Onboarding. Snippets sind vorerst gemockte Platzhalter.',
        recommendedTemplateTitle: 'Empfohlenes Template',
        recommendedTemplateDescription:
            'Platzhalterbereich für Template-Vorschläge basierend auf Onboarding-Zielen und Build-Modus.',
        starterPipelineTitle: 'Starter-Content-Pipeline',
        starterPipelineDescription:
            'Vorgeschlagene Setup-Karten, Starter-Prompts und vorausgefüllte Quellverknüpfungen werden hier angezeigt.',
        applyTemplate: 'Template anwenden',
        consoleTitle: 'Konsole / Antwortbereich',
        consoleDescription: 'Platzhalter für SDK-Antworten, Request-Traces und die erste erfolgreiche Ausgabe.',
        consoleStatus: 'Status: wartet auf Live-Backend-Integration…',
        consoleReady: 'Mock-Antwortbereich bereit'
    },
    home: {
        title: 'Startseite',
        unlimited: 'Unbegrenzt',
        apiUsage: '// API-Nutzung',
        publishJobsPerDay: 'Veröffentlichungsaufträge pro Tag',
        last7Days: 'Letzte 7 Tage',
        jobsOnDate: '{{count}} Veröffentlichungsaufträge am {{date}}',
        noJobsLast7Days: 'Keine Veröffentlichungsaufträge in den letzten 7 Tagen',
        usageUnavailable: 'Nutzungsdaten sind nicht verfügbar',
        postsUsed: '@{{account}} · {{used}} / {{limit}} Beiträge verwendet',
        resetsOn: 'zurückgesetzt am {{date}}',
        noQuotaPeriod: 'Kein Kontingentzeitraum',
        gettingStarted: '// Erste Schritte',
        recentJobs: '// Letzte Aufträge',
        loadingRecentJobs: 'Letzte Aufträge werden geladen…',
        recentJobsUnavailable: 'Letzte Aufträge sind nicht verfügbar.',
        noPublishingJobs: 'Noch keine Veröffentlichungsaufträge.',
        untitledPost: 'Unbenannter Beitrag',
        activeKeyCount: '{{count}} aktiver API-Schlüssel',
        loadingDescription: 'Organisationsübersicht wird geladen…',
        stats: {
            connectedAccounts: 'Verbundene Konten',
            sourcesInPlan: '{{count}} Quellen in deinem Plan enthalten',
            postsLeft: 'Verbleibende Beiträge in diesem Zeitraum',
            postsAcrossAccounts: '{{count}} Beiträge über verbundene Konten',
            scheduledJobs: 'Geplante Aufträge'
        },
        checklist: {
            createOrganization: 'Organisation erstellen',
            connectSocialAccount: 'Social-Media-Konto verbinden',
            socialAccountDetail: 'Instagram oder X',
            createApiKey: 'API-Schlüssel erstellen',
            apiKeyScopes: 'publishing:read · publishing:publish',
            publishFirstPost: 'Ersten Beitrag veröffentlichen',
            publishEndpoint: 'POST /publishing/jobs'
        },
        actions: {
            createPost: 'Beitrag erstellen',
            start: 'Starten',
            viewAll: 'Alle anzeigen',
            viewApiDocs: 'API-Dokumentation öffnen',
            createApiKey: 'API-Schlüssel erstellen',
            connectAccount: 'Konto verbinden',
            viewInsights: 'Insights ansehen',
            inviteMember: 'Mitglied einladen'
        },
        quickActions: '// Schnellaktionen',
        quickActionsTitle: 'Mit deiner Organisation entwickeln',
        quickActionsDescription: 'Starte mit den Tools, die bereits mit deinem Workspace verbunden sind.',
        status: {
            published: 'Veröffentlicht',
            processing: 'Wird verarbeitet',
            scheduled: 'Geplant',
            other: 'Unbekannt'
        }
    },
    settings: {
        pageTitle: 'Einstellungen',
        pageDescription: 'Verwalte deine Organisationseinstellungen und Präferenzen.',
        general: 'Allgemein',
        notifications: 'Benachrichtigungen',
        danger: 'Gefahrenbereich',
        billing: {
            tab: 'Abrechnung',
            title: 'Abrechnung',
            description: 'Prüfe den aktuellen Abrechnungsstatus für {{organizationName}}.',
            currentPlanEyebrow: '// aktueller plan',
            entitlementsEyebrow: '// berechtigungen',
            noOrganizationTitle: 'Keine Organisation ausgewählt',
            noOrganizationDescription:
                'Wähle oder erstelle eine Organisation, um Abonnement- und Abrechnungsdetails anzuzeigen.',
            portalFooter: 'Die Abrechnung läuft über Stripe. Verwalte Karten und Rechnungen im Kundenportal.',
            lifetimeBadge: 'Lifetime',
            lifetimeFooter:
                'Diese Organisation nutzt einen Lifetime-Plan und wird nicht über Stripe abgerechnet, es gibt also keine Karten oder Rechnungen zu verwalten. Wende dich an invisibleapi, um den Plan zu ändern.',
            cancelAtPeriodEndNotice:
                'Dieses Abonnement ist so eingestellt, dass es am Ende des aktuellen Abrechnungszeitraums endet.',
            manageBillingDisabledNoOrganization: 'Erstelle oder wähle zuerst eine Organisation aus.',
            manageBillingDisabledNoCustomer: 'Diese Organisation hat noch keinen Stripe-Kunden.',
            manageBillingDisabledLifetime:
                'Ein Lifetime-Plan wird nicht über Stripe abgerechnet und hat daher kein Kundenportal.',
            priceAfterTrialValue: '{{price}}/{{interval}}',
            postsLimitValue: '{{count}} Beiträge pro verbundenem Account und Zeitraum.',
            noActivePlanTitle: 'Kein aktiver Plan',
            capabilitiesTitle: 'Funktionen',
            limitsTitle: 'Limits',
            emptyBillingState: 'Für die ausgewählte Organisation sind noch keine Abrechnungsdaten verfügbar.',
            emptyCapabilities: 'Keine Funktionsdaten zurückgegeben.',
            emptyLimits: 'Keine Limitdaten zurückgegeben.',
            fields: {
                subscriptionStatus: 'Abonnementstatus',
                billingInterval: 'Abrechnungsintervall',
                quantity: 'Quellen (Anzahl)',
                priceAfterTrial: 'Preis nach der Testphase',
                trialEndsAt: 'Testphase endet',
                currentPeriod: 'Aktueller Zeitraum',
                accessPeriod: 'Zugriffszeitraum',
                cancelAtPeriodEnd: 'Zum Periodenende kündigen'
            },
            subscriptionStatuses: {
                active: 'Aktiv',
                trialing: 'In der Testphase',
                incomplete: 'Unvollständig',
                incomplete_expired: 'Unvollständig abgelaufen',
                past_due: 'Überfällig',
                canceled: 'Gekündigt',
                unpaid: 'Unbezahlt',
                paused: 'Pausiert'
            },
            billingIntervals: {
                monthly: 'Monatlich',
                yearly: 'Jährlich'
            },
            boolean: {
                yes: 'Ja',
                no: 'Nein'
            },
            errors: {
                generic: 'Abrechnungsdaten konnten nicht geladen werden.'
            },
            checkout: {
                loading: 'Weiterleitung…'
            },
            customerPortal: {
                open: 'Abrechnung verwalten',
                loading: 'Portal wird geöffnet…'
            },
            returnState: {
                success: 'Abrechnungs-Checkout abgeschlossen. Abrechnungsstatus wird aktualisiert…',
                cancel: 'Abrechnungs-Checkout wurde abgebrochen.',
                portalReturn: 'Vom Abrechnungsportal zurückgekehrt. Abrechnungsstatus wird aktualisiert…'
            }
        },
        generalTitle: 'Allgemeine Einstellungen',
        generalDescription: 'Konfiguriere den Namen deiner Organisation und grundlegende Einstellungen.',
        workspaceName: 'Organisationsname',
        workspaceSlug: 'Organisations-Slug',
        timezone: 'Zeitzone',
        settingsSaved: 'Einstellungen gespeichert',
        notificationsSaved: 'Benachrichtigungseinstellungen gespeichert',
        notificationsTitle: 'Benachrichtigungseinstellungen',
        notificationsDescription: 'Wähle aus, wie und wann du benachrichtigt werden möchtest.',
        emailNotifications: 'E-Mail-Benachrichtigungen',
        emailNotificationsDescription: 'Erhalte E-Mail-Updates über Aktivitäten in der Organisation.',
        pushNotifications: 'Push-Benachrichtigungen',
        pushNotificationsDescription: 'Erhalte Benachrichtigungen im Browser über wichtige Ereignisse.',
        weeklyDigest: 'Wöchentliche Zusammenfassung',
        weeklyDigestDescription: 'Erhalte eine wöchentliche Zusammenfassung der Aktivitäten in der Organisation.',
        dangerTitle: 'Gefahrenbereich',
        dangerDescription: 'Unumkehrbare Aktionen, die deine Organisation betreffen.',
        deleteWorkspace: 'Organisation löschen',
        deleteWorkspaceDescription: 'Diese Organisation und alle zugehörigen Daten dauerhaft löschen.',
        deleteUnavailable: 'Diese Aktion ist in der Vorlage nicht verfügbar.',
        exportData: 'Daten exportieren',
        exportDataDescription: 'Lade einen vollständigen Export deiner Organisationsdaten herunter.',
        exportStarted: 'Export gestartet — du wirst benachrichtigt, wenn er bereit ist.',
        savePreferences: 'Einstellungen speichern'
    },
    accountDetails: {
        pageTitle: 'Kontodetails',
        pageDescription: 'Verwalte deine Profildaten und die Sicherheitsaktionen für dein Konto.',
        loadErrorTitle: 'Kontodetails konnten nicht geladen werden',
        retry: 'Erneut versuchen',
        managedBadge: 'Zentral verwaltet',
        readOnlyBadge: 'Schreibgeschützt',
        emptyValue: 'Nicht gesetzt',
        fields: {
            firstName: 'Vorname',
            lastName: 'Nachname',
            username: 'Benutzername',
            email: 'E-Mail'
        },
        personalInfo: {
            title: 'Persönliche Informationen',
            description: 'Aktualisiere die Profilfelder, die für dieses Konto bearbeitbar sind.',
            sourceHint:
                'Benutzername und E-Mail stammen aus deinen Anmeldedaten und können hier nicht bearbeitet werden.',
            saving: 'Wird gespeichert...',
            reset: 'Änderungen zurücksetzen',
            saveSuccessToast: 'Kontodetails gespeichert.',
            validationErrorToast: 'Prüfe die markierten Felder und versuche es erneut.'
        },
        security: {
            title: 'Authentifizierung & Sicherheit',
            description:
                'Starte Sicherheitsabläufe für das Konto über Backend-Aktionen. Admin-Zugriff erreicht nie den Browser.',
            emailFlowBadge: 'Sicherer E-Mail-Ablauf',
            password: {
                title: 'Basis-Authentifizierung',
                description:
                    'Sende dir die E-Mail zur Passwortänderung und schließe die Änderung im sicheren E-Mail-Ablauf ab.',
                methodLabel: 'Methode zur Passwortänderung',
                methodValue: 'Sicherer E-Mail-Ablauf',
                action: 'E-Mail zur Passwortänderung senden',
                sending: 'E-Mail wird gesendet...',
                successToast: 'E-Mail zur Passwortänderung angefordert. Prüfe deinen Posteingang.',
                successInline: 'E-Mail angefordert. Prüfe deinen Posteingang für den Ablauf zur Passwortänderung.'
            },
            twoFactor: {
                title: 'Zwei-Faktor-Authentifizierung',
                description:
                    'Sende dir die E-Mail zur Einrichtung und konfiguriere eine Authenticator-App über diesen Ablauf.',
                methodLabel: 'Methode zur Zwei-Faktor-Einrichtung',
                methodValue: 'Sicherer E-Mail-Ablauf',
                action: 'E-Mail zur Zwei-Faktor-Einrichtung senden',
                sending: 'E-Mail wird gesendet...',
                successToast: 'E-Mail zur Zwei-Faktor-Einrichtung angefordert. Prüfe deinen Posteingang.',
                successInline:
                    'E-Mail angefordert. Prüfe deinen Posteingang für den Ablauf zur Zwei-Faktor-Einrichtung.'
            }
        }
    },
    sidebar: {
        appName: 'SaaS-App',
        workspace: 'Organisation',
        login: 'Anmelden',
        logout: 'Abmelden',
        signedIn: 'Angemeldet',
        openSignIn: 'Anmeldung öffnen',
        account: 'Konto',
        accountDetails: 'Kontodetails',
        organizationMenu: 'Organisationen',
        organizations: 'Organisationen',
        currentOrganization: 'Aktuell',
        noOrganization: 'Noch keine Organisation',
        language: 'Sprache',
        languageSelector: 'Sprache auswählen',
        languages: {
            en: 'Englisch',
            de: 'Deutsch',
            es: 'Spanisch',
            fr: 'Französisch',
            mk: 'Mazedonisch',
            jp: 'Japanisch'
        }
    },
    nav: {
        home: 'Startseite',
        organizations: 'Organisationen',
        socialAccounts: 'Social-Media-Konten',
        publishing: 'Veröffentlichung',
        insights: 'Einblicke',
        members: 'Mitglieder',
        invitations: 'Einladungen',
        apiKeys: 'API-Schlüssel',
        apiDocs: 'API-Dokumente',
        settings: 'Einstellungen',
        pricing: 'Preise',
        content: 'Inhalt',
        audience: 'Zielgruppe',
        advancedQuery: 'Erweiterte Abfrage',
        main: 'Hauptbereich'
    },
    publishing: {
        pageTitle: 'Veröffentlichung',
        pageDescription: 'Prüfe Veröffentlichungsjobs für {{organizationName}} und den aktuellen Auslieferungsstatus.',
        emptyOrganizationDescription:
            'Wähle eine Organisation aus oder erstelle eine, um Veröffentlichungsjobs anzuzeigen.',
        empty: 'Noch keine Veröffentlichungsjobs gefunden.',
        refreshAction: 'Jobs neu laden',
        refreshDescription: 'Lädt die neuesten Veröffentlichungsjobs erneut vom Server.',
        deliveryRecordsTitle: 'Bedeutung der Auslieferungseinträge',
        deliveryRecordsDescription:
            'Jeder Auslieferungseintrag steht für einen plattformspezifischen Zustellversuch oder ein Ergebnis für ein ausgewähltes Social-Media-Konto. So kannst du nachvollziehen, was pro Ziel passiert ist.',
        scheduledFor: 'Geplant für {{value}}',
        pagination: {
            previous: 'Zurück',
            next: 'Weiter',
            page: 'Seite {{page}}',
            summary: 'Seite {{page}} · {{count}} Jobs angezeigt (bis zu {{perPage}} pro Seite)',
            summaryCompact: '{{count}} Jobs · Seite {{page}} von {{totalPages}}'
        },
        createAction: 'Beitrag erstellen',
        subscriptionInactiveDescription:
            'Neue Beiträge und Wiederholungen fehlgeschlagener Jobs sind pausiert, bis das Abonnement dieser Organisation erneuert wurde.',
        previewAction: 'Vorschau',
        previewPostAction: 'Beitragsvorschau',
        actionsMenuLabel: 'Aktionsmenü öffnen',
        viewDetailsAction: 'Details anzeigen',
        copyJobIdAction: 'Job-ID kopieren',
        jobIdCopied: 'Job-ID kopiert.',
        retryAction: 'Erneut versuchen',
        cancelAction: 'Abbrechen',
        retryUnavailable: 'Erneutes Versuchen ist aus der Veröffentlichungsliste noch nicht verfügbar.',
        cancelUnavailable: 'Abbrechen ist aus der Veröffentlichungsliste noch nicht verfügbar.',
        emptyStateTitle: 'Noch keine Veröffentlichungsjobs',
        noCaptionShort: 'Keine Bildunterschrift',
        technicalDetailsAction: 'Technische Details',
        technicalDetailsTitle: 'Technische Details des Veröffentlichungsjobs',
        technicalDetailsDescription:
            'Prüfe die Rohdaten des Veröffentlichungsjobs und die Auslieferungsdetails für diesen Job.',
        previewTitle: 'Vorschau des Veröffentlichungsjobs',
        previewDescription: 'Prüfe den aktuell gespeicherten Status dieses Veröffentlichungsjobs.',
        previewLoading: 'Details des Veröffentlichungsjobs werden geladen…',
        instagram: {
            follow: 'Folgen',
            mediaAlt: 'Instagram-Medienvorschau',
            multiAsset: '{{count}} Elemente',
            commentPlaceholder: 'Kommentiere…',
            justNow: 'gerade eben'
        },
        noCaption: 'Keine Bildunterschrift angegeben.',
        noMediaItems: 'Diesem Veröffentlichungsjob wurden keine Medienelemente hinzugefügt.',
        noDeliveries: 'Für diesen Veröffentlichungsjob sind noch keine Auslieferungseinträge verfügbar.',
        failureTitle: 'Fehlerdetails',
        mediaItemsCount: '{{count}} Medienelemente',
        deliveriesCount: '{{count}} Auslieferungseinträge',
        columns: {
            status: 'Status',
            caption: 'Bildunterschrift',
            targets: 'Auslieferungen',
            createdAt: 'Erstellt',
            publishedAt: 'Veröffentlicht',
            actions: 'Aktionen',
            actionsDescription: 'Öffnet die Vorschau- und Detailansicht dieses Veröffentlichungsjobs.'
        },
        fields: {
            status: 'Status',
            createdAt: 'Erstellt am',
            updatedAt: 'Aktualisiert am',
            publishedAt: 'Veröffentlicht am',
            caption: 'Bildunterschrift',
            firstComment: 'Erster Kommentar',
            requestedPublishAt: 'Geplant für',
            mediaItems: 'Medienelemente',
            captionHelp: 'Halte den Text kurz und plattformtauglich. Du kannst alles vor dem Absenden prüfen.',
            firstCommentHelp:
                'Optional. Wird nach dem Hauptinhalt veröffentlicht, falls die Zielplattform das unterstützt.',
            mediaType: 'Medientyp',
            sourceUrl: 'Quell-URL',
            publicFetchUrl: 'Öffentliche Abruf-URL',
            altText: 'Alternativtext',
            deliveries: 'Auslieferungen',
            failureCode: 'Fehlercode',
            failureMessage: 'Fehlermeldung'
        },
        status: {
            pending: 'Ausstehend',
            queued: 'In Warteschlange',
            scheduled: 'Geplant',
            processing: 'Wird verarbeitet',
            published: 'Veröffentlicht',
            failed: 'Fehlgeschlagen',
            canceled: 'Abgebrochen'
        }
    },

    publishingComposer: {
        pageTitle: 'Beitrag erstellen',
        pageDescription:
            'Erstelle einen Veröffentlichungsjob für {{organizationName}} und sende ihn an den Publishing-Workflow.',
        backToList: 'Zurück zur Veröffentlichung',
        emptyOrganizationTitle: 'Keine Organisation ausgewählt',
        emptyOrganizationDescription:
            'Wähle eine Organisation aus oder erstelle eine, bevor du einen Veröffentlichungsjob erstellst.',
        publishTimeHint:
            'Lege fest, ob dieser Beitrag sofort oder zu einer geplanten lokalen Uhrzeit veröffentlicht werden soll.',
        localTimezoneHint: 'Die geplante Zeit verwendet deine aktuelle lokale Zeitzone.',
        connectAccountsAction: 'Social-Media-Konten öffnen',
        platformHint:
            'Wähle aus, wo dieser Beitrag veröffentlicht werden soll. Instagram und X können veröffentlichen, wenn ein aktiv verbundenes Konto verfügbar ist.',
        socialAccountHint: 'Wähle das verbundene Social-Media-Konto aus, das diesen Beitrag erhalten soll.',
        socialAccountAutoSelected: 'Dein einziges geeignetes verbundenes Konto wurde automatisch vorausgewählt.',
        selectSocialAccountAction: 'Social-Media-Konto auswählen',
        selectedAccountsSummary: '{{count}} ausgewählte Konten',
        selectedPlatformsLabel: 'Wird veröffentlicht auf',
        limits: {
            checking: 'Veröffentlichungsnutzung wird geprüft…',
            remaining: '{{count}} Beiträge in diesem Zeitraum übrig',
            exhausted: 'Limit für diesen Zeitraum erreicht',
            exhaustedWithReset: 'Limit erreicht. Wird am {{resetAt}} zurückgesetzt',
            selectedExhaustedWarning:
                'Für {{account}} ist kein Veröffentlichungskontingent mehr übrig. Es wird am {{resetAt}} zurückgesetzt.',
            selectedExhaustedWarningNoReset: 'Für {{account}} ist kein Veröffentlichungskontingent mehr übrig.',
            unavailable:
                'Die Veröffentlichungsnutzung ist aktuell nicht verfügbar. Du kannst trotzdem veröffentlichen; die Backend-Limits werden beim Absenden geprüft.'
        },
        noEligibleAccountsTitle: 'Keine Veröffentlichungskonten verfügbar',
        noEligibleAccountsDescription: 'Verbinde ein Instagram- oder X-Konto, bevor du einen Beitrag erstellst.',
        noHandle: 'Kein öffentlicher Benutzername verfügbar',
        selectedBadge: 'Ausgewählt',
        notSelectedBadge: 'Nicht ausgewählt',
        comingSoon: 'Demnächst',
        additionalMediaItemsTitle: 'Zusätzliche Medienelemente',
        additionalMediaItemsDescription: 'Beibehalten für Karussellbeiträge, X-Posts und Videos.',
        mediaPublicUrlHint: 'Medien werden als öffentliche URL übergeben.',
        noAccountsBadge: 'Kein Konto',
        mediaStepHint: 'Füge die Mediendetails und die Beschriftung für diesen Beitrag hinzu.',
        textOnlyHint: 'Textbeiträge auf X senden die Beschriftung ohne Medienelemente.',
        instagramNoImageHint: 'Ohne hochgeladenes Bild wird dieser Beitrag nicht auf Instagram veröffentlicht.',
        mediaItemsTitle: 'Medienelemente',
        mediaItemsHint: 'Füge ein oder mehrere Bilder oder Videos hinzu, wenn dieser Beitrag Medien enthalten soll.',
        multiMediaBadge: '{{count}} Medien',
        addMediaAction: 'Medien zum Beitrag hinzufügen',
        removeMediaAction: 'Entfernen',
        mediaItemTitle: 'Medienelement {{index}}',
        publicFetchUrlMirrorsSourceHint:
            'Das Backend benötigt eine sourceUrl. Dieses Feld wird beim Absenden sowohl für sourceUrl als auch für publicFetchUrl verwendet.',
        altTextPlaceholder: 'Barrierefreie Beschreibung für dieses Medienelement',
        captionPlaceholder: 'Schreibe die Beschriftung für die Veröffentlichung…',
        submitAction: 'Beitrag veröffentlichen',
        scheduleSubmitAction: 'Beitrag planen',
        subscriptionInactiveDescription:
            'Erneuere das Abonnement dieser Organisation, bevor du einen neuen Veröffentlichungsjob erstellst.',
        stepCompleteBadge: 'Fertig',
        submitting: 'Wird veröffentlicht...',
        successToast: 'Veröffentlichungsjob erstellt.',
        successToastScheduled: 'Veröffentlichungsjob geplant.',
        livePreviewTitle: 'Live-Vorschau',
        livePreviewDescription: 'Sieh dir den Beitrag während des Erstellens an oder öffne ihn im Vollbild.',
        fullscreenPreviewAction: 'Vollbild',
        selectDateAction: 'Datum auswählen',
        previewAccountPlaceholder: 'Ausgewähltes Social-Media-Konto',
        previewHandlePlaceholder: '@konto',
        previewMediaPlaceholder: 'Medienvorschau',
        previewCaptionPlaceholder: 'Deine Beschriftung erscheint hier während der Eingabe.',
        previewAdditionalMediaCount: '+{{count}} mehr',
        previewScheduledBadge: 'Geplant',
        videoPreviewLabel: 'Videovorschau',
        twitterPreviewComingSoon: 'Die Twitter/X-Vorschau verwendet das ausgewählte X-Konto und den Beitragsinhalt.',
        postPublishingTitle: 'Beitrag veröffentlichen',
        stepFlowTitle: 'Schritt-für-Schritt-Composer',
        stepFlowDescription:
            'Vervollständige jeden Block der Reihe nach. Spätere Blöcke bleiben gesperrt, bis der vorherige bereit ist.',
        publishModes: {
            now: 'Jetzt veröffentlichen',
            nowDescription: 'Starte den Veröffentlichungs-Workflow sofort nach dem Absenden.',
            scheduled: 'Für später planen',
            scheduledDescription: 'Plane diesen Beitrag für ein zukünftiges Datum und eine Uhrzeit ein.'
        },
        platforms: {
            instagram: 'Instagram',
            twitter: 'Twitter / X'
        },
        steps: {
            socialAccounts: 'Social-Media-Konten',
            targets: 'Ziele',
            publishingTime: 'Veröffentlichungszeit',
            postContent: 'Beitragsinhalt'
        },
        fields: {
            platform: 'Zielplattform',
            socialAccount: 'Social-Media-Konto',
            mediaItems: 'Medienelemente',
            mediaUrl: 'Medien-URL',
            captionHelp: 'Halte den Text kurz und plattformtauglich.',
            mediaType: 'Medientyp',
            sourceUrl: 'Quell-URL',
            publicFetchUrl: 'Öffentliche Abruf-URL',
            altText: 'Alternativtext',
            caption: 'Beschriftung',
            requestedPublishAt: 'Geplant für',
            scheduleDate: 'Datum',
            publishTime: 'Veröffentlichungszeit',
            publishAtLocalTime: 'Veröffentlichen um (lokale Zeit)',
            scheduleTime: 'Uhrzeit'
        },
        placeholders: {
            primaryMediaUrl: 'https://cdn.yourapp.com/photo.jpg',
            additionalMediaUrl: 'https://cdn.example.com/post-image.jpg'
        },
        mediaTypes: {
            text: 'Nur Text',
            image: 'Bild',
            video: 'Video'
        },
        validation: {
            generic: 'Prüfe das Veröffentlichungsformular und korrigiere die markierten Felder.',
            socialAccountRequired: 'Wähle ein Social-Media-Konto aus, bevor du fortfährst.',
            platformRequired: 'Wähle eine verfügbare Zielplattform aus.',
            mediaItemRequired: 'Füge für die ausgewählten Plattformen mindestens ein Medienelement hinzu.',
            mediaTypeInvalid: 'Reine Textbeiträge sind nur für X verfügbar.',
            publishModeRequired: 'Wähle eine Veröffentlichungszeitoption aus, bevor du fortfährst.',
            captionRequired: 'Eine Beschriftung ist erforderlich.',
            publicFetchUrlRequired: 'Die öffentliche Abruf-URL ist erforderlich.',
            publicFetchUrlInvalid: 'Die öffentliche Abruf-URL muss eine gültige URL sein.',
            xCarouselImagesOnly:
                'X-Karussellbeiträge unterstützen nur Bilder. Veröffentliche ein Video auf X als Beitrag mit einem einzelnen Medium.',
            xCarouselImageCount: 'X-Karussellbeiträge unterstützen höchstens {{count}} Bilder.',
            requestedPublishAtRequired: 'Wähle ein geplantes Datum und eine Uhrzeit.',
            requestedPublishAtInvalid: 'Das geplante Datum und die Uhrzeit müssen gültig sein.',
            requestedPublishAtFuture: 'Das geplante Datum und die Uhrzeit müssen in der Zukunft liegen.'
        }
    },

    insights: {
        pageTitle: 'Instagram-Einblicke',
        pageDescription: 'Wähle ein Konto und einen Datumsbereich. Die Seite aktualisiert sich anhand dieser beiden Filter.',
        emptyOrganizationDescription:
            'Wähle eine Organisation aus oder erstelle eine, um Instagram-Einblicke anzuzeigen.',
        accountPickerLabel: 'Instagram-Konto',
        accountPickerPlaceholder: 'Konto auswählen',
        noInsightsAccounts:
            'Noch kein verbundenes Instagram-Konto unterstützt Einblicke. Verbinde zuerst ein professionelles Instagram-Konto.',
        noInsightsAccountsHelp:
            'Verbinde ein Instagram-Konto mit Einblicke-Zugriff, um Übersichtsmetriken, Zielgruppen-Demografie und Content-Aufschlüsselungen freizuschalten.',
        subscriptionInactiveTitle: 'Insights pausiert',
        subscriptionInactiveDescription:
            'Instagram-Insights werden nicht aktualisiert, solange das Abonnement dieser Organisation inaktiv ist.',
        subscriptionInactiveHelp: 'Erneuere das Abonnement, um wieder neue Insights-Daten abzurufen.',
        connectAccountCta: 'Zu den sozialen Konten',
        dateRangeLabel: 'Zeitraum',
        dateRange: {
            last7Days: 'Letzte 7 Tage',
            last14Days: 'Letzte 14 Tage',
            last30Days: 'Letzte 30 Tage'
        },
        overviewTitle: 'Übersicht',
        tabs: {
            overview: 'Übersicht',
            content: 'Content-Aufschlüsselung',
            trend: 'Verlauf',
            breakdowns: 'Aufschlüsselungen',
            audience: 'Zielgruppe',
            advanced: 'Erweiterte Abfrage'
        },
        currentViewLabel: 'Aktuelle Ansicht',
        currentViewTitle: 'Einblicke zum Instagram-Konto',
        currentViewDescription:
            'Die Übersichtskarten zeigen die wichtigsten Zahlen. Nutze die Tabs unten für Verlauf, Aufschlüsselung, Zielgruppe und Rohabfragen.',
        trendTitle: 'Reichweite im Zeitverlauf',
        trendTitleWithMetric: '{{metric}} im Zeitverlauf',
        trendDescription: 'Erreichte eindeutige Konten pro Tag im ausgewählten Zeitraum.',
        trendTracking: '{{metric}} wird über den ausgewählten Zeitraum verfolgt.',
        chartValueLabel: 'Wert',
        overviewSectionPrimaryLabel: '// primär',
        overviewSectionEngagementLabel: '// engagement',
        quickSegmentTitle: 'Schnelle Segmentübersicht',
        quickSegmentDescription: 'Ein schneller Blick auf die stärkste Content-Aufschlüsselung für die aktive Metrik.',
        topSegment: 'Top-Segment',
        topAudience: 'Top-Zielgruppe',
        rankTop: 'Top',
        primaryMetricBadge: 'Primär',
        metricHelpLabel: 'Hilfe zu {{metric}}',
        filtersBadge: 'Instagram-Einblicke',
        filtersTitle: 'Dashboard fokussieren',
        filtersDescription:
            'Wähle ein Konto und einen Zeitraum. Die Seite aktualisiert sich anhand dieser beiden Filter.',
        filtersAction: 'Filter',
        filtersSheetTitle: 'Einblicke-Filter',
        filtersSheetDescription: 'Passe Konto und Zeitraum für das Dashboard an.',
        breakdownTitle: 'Metrik-Aufschlüsselungen',
        breakdownDescription: 'Teile eine Metriksumme nach einer unterstützten Dimension auf.',
        breakdownMetricLabel: 'Metrik',
        breakdownDimensionLabel: 'Aufschlüsselung',
        breakdownColumns: {
            rank: 'Rang',
            dimension: 'Dimension',
            value: 'Wert',
            share: 'Anteil'
        },
        breakdownTotal: 'Gesamt: {{value}}',
        audienceTitle: 'Zielgruppen-Demografie',
        audienceDescription: 'Wer diesem Konto folgt und damit interagiert.',
        audienceMetricLabel: 'Zielgruppe',
        audienceMetrics: {
            follower_demographics: 'Follower',
            engaged_audience_demographics: 'Interagierende Zielgruppe'
        },
        audienceBreakdownLabel: 'Gruppieren nach',
        audienceBreakdowns: {
            country: 'Land',
            city: 'Stadt',
            age: 'Alter',
            gender: 'Geschlecht'
        },
        audienceTimeframeLabel: 'Zeitfenster',
        audienceTimeframes: {
            this_week: 'Diese Woche',
            this_month: 'Dieser Monat'
        },
        advancedTitle: 'Erweiterte Abfrage',
        advancedDescription: 'Sende eine eigene Abfrage an die Instagram-Einblicke-API und prüfe die Rohantwort.',
        advancedExplorerDescription:
            'Der Explorer ist bewusst zweitrangig. Nutze ihn, um Randfall-Metriken, nicht unterstützte Aufschlüsselungen und rohe API-Payloads zu validieren.',
        advancedBadges: {
            rawApiQueryBuilder: 'Roh-API-Abfragebuilder',
            debugFirst: 'Debug zuerst'
        },
        advancedMetricLabel: 'Metriken (durch Komma getrennt)',
        advancedMetricPlaceholder: 'reach',
        advancedPeriodLabel: 'Periode',
        advancedMetricTypeLabel: 'Metriktyp',
        advancedBreakdownLabel: 'Aufschlüsselung',
        advancedBreakdownPlaceholder: 'media_product_type',
        advancedTimeframeLabel: 'Zeitfenster',
        advancedSinceLabel: 'Von',
        advancedUntilLabel: 'Bis',
        advancedRun: 'Abfrage ausführen',
        advancedNone: 'Keine',
        advancedPeriods: {
            day: 'Tag',
            week: 'Woche',
            days_28: '28 Tage',
            lifetime: 'Gesamtlaufzeit'
        },
        advancedMetricTypes: {
            total_value: 'Gesamtwert',
            time_series: 'Zeitreihe'
        },
        rawResponseTitle: 'Rohantwort',
        metrics: {
            reach: 'Reichweite',
            accounts_engaged: 'Interagierende Konten',
            total_interactions: 'Interaktionen gesamt',
            likes: '„Gefällt mir“-Angaben',
            comments: 'Kommentare',
            shares: 'Geteilte Inhalte',
            saves: 'Gespeichert',
            views: 'Aufrufe',
            follows_and_unfollows: 'Follows und Unfollows',
            profile_links_taps: 'Profil-Link-Taps'
        },
        metricDescriptions: {
            reach: 'Eindeutige Konten, die Kontoinhalte im ausgewählten Zeitraum gesehen haben.',
            accounts_engaged: 'Eindeutige Konten, die mit den Kontoinhalten interagiert haben.',
            total_interactions: 'Kombinierte Interaktionen über unterstützte Engagement-Aktionen.',
            default: 'Übergeordnete Konto-Insight-Metrik.'
        },
        breakdownDimensions: {
            REELS: 'Reels',
            POSTS: 'Beiträge',
            STORIES: 'Stories',
            CAROUSEL_CONTAINER: 'Karussell-Beiträge',
            FOLLOWER: 'Follower',
            NON_FOLLOWER: 'Nicht-Follower',
            FOLLOWERS: 'Follower',
            NON_FOLLOWERS: 'Nicht-Follower',
            MEDIA_PRODUCT_TYPE: 'Medienprodukttyp',
            FOLLOW_TYPE: 'Follow-Typ',
            CONTACT_BUTTON_TYPE: 'Kontaktbutton-Typ',
            THIS_WEEK: 'Diese Woche',
            THIS_MONTH: 'Dieser Monat',
            UNKNOWN: 'Unbekannt',
            M: 'Männlich',
            F: 'Weiblich',
            U: 'Unbekannt'
        },
        noData: 'Für diese Abfrage wurden keine Daten zurückgegeben.',
        retry: 'Erneut versuchen',
        unknownError: 'Unbekannter Fehler'
    },
    apiDocs: {
        pageTitle: 'API-Dokumente',
        pageDescription: 'Schnellstart, Endpunkt-Referenzen und eingebettete API-Dokumentation an einem Ort.',
        openFullDocumentation: 'Vollständige Dokumentation öffnen',
        subscriptionInactiveDescription:
            'API-Schlüssel der Organisation sind pausiert, solange der Abonnementzugang inaktiv ist. Authentifizierte API-Anfragen für diese Organisation schlagen fehl, bis die Abrechnung erneuert wird.',
        shell: {
            defaultDocsLocaleLabel: 'Standard',
            fallbackNotice:
                'Für die Frontend-Sprache {{frontendLanguage}} gibt es kein eigenes Docs-Artefakt, daher wurde auf {{docsLanguage}} zurückgegriffen.',
            organizationIdLabel: 'Aktive Organisations-ID',
            organizationIdDescription:
                'Verwende diese ID, wenn ein API-Endpunkt den Pfadparameter der aktiven Organisation benötigt.',
            copyOrganizationId: 'Organisations-ID kopieren',
            organizationIdCopied: 'Organisations-ID kopiert.',
            noActiveOrganizationId: 'Keine aktive Organisation ausgewählt.',
            iframeRegionLabel: 'Container für eingebettete API-Dokumente',
            iframeTitle: 'Eingebettete API-Dokumente für {{language}}',
            loadErrorTitle: 'Docs-Manifest konnte nicht geladen werden',
            loadErrorDescription: 'Das Docs-Manifest konnte nicht geladen werden: {{error}}',
            loadErrorFallback: 'Unbekannter Fehler beim Docs-Manifest.',
            noDocsTitle: 'Keine generierten Docs-Artefakte gefunden',
            noDocsDescription:
                'Das Docs-Manifest wurde geladen, aber es waren keine generierten statischen Docs-Seiten zum Einbetten verfügbar.'
        }
    },
    socialAccounts: {
        pageTitle: 'Social-Media-Konten',
        loadingDescription: 'Social-Media-Konten werden geladen...',
        pageDescription: 'Verwalte die verbundenen Social-Media-Konten für deine Organisation.',
        subscriptionInactiveDescription:
            'Das Hinzufügen oder erneute Verbinden von Social-Media-Konten ist pausiert, bis das Abonnement dieser Organisation erneuert wurde.',
        sourceLimit: {
            title: 'Quellenlimit erreicht',
            description:
                'Diese Organisation nutzt {{used}} von {{limit}} gekauften Quellen. Kaufe weitere Quellen, bevor du ein weiteres Konto verbindest.',
            actionBlockedToast:
                'Quellenlimit erreicht. Kaufe weitere Quellen, bevor du ein weiteres Social-Media-Konto verbindest.',
            checking: 'Quellenlimit wird geprüft…',
            unavailable: 'Das Verbinden neuer Konten ist pausiert, bis das Quellenlimit erneut geprüft werden kann.',
            unavailableTitle: 'Quellenlimit konnte nicht geprüft werden',
            unavailableRetry: 'Prüfung wiederholen',
            manageBillingAction: 'Abrechnung verwalten',
            ownerHint: 'Bitte einen Organisationsinhaber oder Admin, weitere Quellen zu kaufen.'
        },
        searchPlaceholder: 'Social-Media-Konten durchsuchen',
        rowsPerPage: 'Zeilen pro Seite',
        empty: 'Keine Social-Media-Konten gefunden.',
        emptyState: {
            title: 'Noch keine Konten verbunden'
        },
        table: {
            title: 'Verbundene Konten',
            totalCount: '{{count}} Konten insgesamt'
        },
        columns: {
            id: 'ID',
            accountName: 'Kontoname',
            type: 'Typ',
            status: 'Status',
            actions: 'Aktionen',
            actionsDescription: 'Öffnet das Aktionsmenü für dieses Konto.'
        },
        actions: {
            menuLabel: 'Kontoaktionen',
            copyId: 'Konto-ID kopieren',
            refresh: 'Erneut verbinden',
            reconnect: 'Erneut verbinden',
            delete: 'Löschen'
        },
        types: {
            instagram: 'Instagram',
            x: 'X'
        },
        statuses: {
            active: 'Verbunden',
            degraded: 'Beeinträchtigt',
            reauthorization_required: 'Erneute Verbindung erforderlich',
            disconnected: 'Getrennt',
            error: 'Fehler'
        },
        pagination: {
            previous: 'Zurück',
            next: 'Weiter',
            page: 'Seite {{page}} von {{totalPages}}',
            summary: '{{start}}-{{end}} von {{total}} Konten',
            summaryCompact_one: '{{count}} Konto · Seite {{page}} von {{totalPages}}',
            summaryCompact_other: '{{count}} Konten · Seite {{page}} von {{totalPages}}'
        },
        connectDialog: {
            trigger: 'Neues Konto hinzufügen',
            title: 'Neues Konto hinzufügen',
            description: 'Wähle eine soziale Quelle zum Verbinden.',
            liveBadge: 'Live',
            comingSoonLabel: '// bald verfügbar',
            trustCopy: 'Du autorisierst dich direkt bei der Plattform. Wir sehen nie dein Passwort.',
            comingSoonPlatforms: {
                tiktok: 'TikTok',
                facebook: 'Facebook',
                linkedin: 'LinkedIn',
                youtube: 'YouTube'
            },
            platforms: {
                instagram: {
                    name: 'Instagram',
                    requirement: 'Business- oder Creator-Konto, verknüpft mit einer Facebook-Seite.'
                },
                x: {
                    name: 'X',
                    requirement: 'Beliebiges X-Konto.'
                }
            },
            connectInstagram: 'Instagram-Konto verbinden',
            connectX: 'X-Konto verbinden'
        },
        deleteDialog: {
            title: 'Social-Media-Konto löschen',
            description: '„{{accountName}}“ aus dieser Organisation löschen?',
            success: 'Social-Media-Konto gelöscht'
        },
        callback: {
            success: 'Social-Media-Konto erfolgreich verbunden',
            error: 'Verbindung des Social-Media-Kontos fehlgeschlagen'
        },
        emptyOrganizationTitle: 'Keine Organisation ausgewählt',
        emptyOrganizationDescription: 'Wähle eine Organisation aus, bevor du Social-Media-Konten verwaltest.',
        errors: {
            missingAuthorization: 'Für dieses Social-Media-Konto wurde keine verwaltbare Autorisierung gefunden.'
        },
        idCopied: 'Social-Media-Konto-ID kopiert'
    },
    organizationMembers: {
        pageTitle: 'Organisationsmitglieder',
        pageDescription: 'Mitglieder für {{organizationName}} verwalten.',
        fallbackOrganizationName: 'die aktuelle Organisation',
        empty: 'Für diese Organisation wurden keine Mitglieder gefunden.',
        count: '{{count}} Mitglieder · Seite {{page}} von {{totalPages}}',
        permissionHint:
            'Deine aktuelle Organisationsrolle erlaubt das Anzeigen dieser Seite, aber Verwaltungsaktionen für Mitglieder sind auf deiner Berechtigungsstufe deaktiviert.',
        genericMember: 'dieses Mitglied',
        roleUpdated: 'Mitgliederrolle aktualisiert',
        lastOwnerBlocked: 'Mindestens ein Eigentümer muss in der Organisation verbleiben.',
        membershipIdCopied: 'Mitgliedschafts-ID kopiert',
        memberActions: 'Mitgliederaktionen',
        changeRoleTo: 'Rolle zu {{role}} ändern',
        memberRemoved: 'Mitglied entfernt',
        removeAction: 'Mitglied entfernen',
        confirmRemoveTitle: 'Organisationsmitglied entfernen',
        confirmRemoveDescription:
            '{{memberName}} aus dieser Organisation entfernen? Diese Aktion kann nicht über die UI rückgängig gemacht werden.',
        columns: {
            member: 'Mitglied',
            role: 'Rolle',
            joinedAt: 'Beitrittsdatum',
            actions: 'Aktionen',
            actionsDescription: 'Öffnet die Vorschau- oder Detailansicht für diesen Veröffentlichungsjob.'
        },
        roles: {
            owner: 'Eigentümer',
            admin: 'Admin',
            member: 'Mitglied',
            viewer: 'Betrachter'
        },
        errors: {
            forbidden: 'Du darfst diese Mitgliederaktion nicht ausführen.',
            notFound: 'Dieses Mitglied oder diese Organisation wurde nicht gefunden.',
            conflict: 'Diese Änderung verstößt gegen die Regeln der Organisationsmitgliedschaft.',
            generic: 'Mitgliederaktion fehlgeschlagen.'
        }
    },
    organizationInvitations: {
        pageTitle: 'Organisationseinladungen',
        pageDescription: 'Einladungen für {{organizationName}} verwalten.',
        fallbackOrganizationName: 'die aktuelle Organisation',
        empty: 'Für diese Organisation wurden keine Einladungen gefunden.',
        emptyDashedTitle: 'Für diese Organisation gibt es noch keine ausstehenden Einladungen.',
        count: '{{count}} Einladungen · Seite {{page}} von {{totalPages}}',
        permissionHint:
            'Deine aktuelle Organisationsrolle erlaubt das Anzeigen von Einladungen, aber Erstellen oder Widerrufen ist auf deiner Berechtigungsstufe deaktiviert.',
        inviteAction: 'Teammitglied einladen',
        dialogTitle: 'Teammitglied einladen',
        dialogDescription: 'Erstelle eine Organisationseinladung und kopiere den einmaligen Token.',
        fields: {
            email: 'E-Mail',
            role: 'Rolle'
        },
        sendInvite: 'Einladung senden',
        inviting: 'Einladung wird erstellt...',
        invitationCreated: 'Einladung erstellt',
        invitationRevoked: 'Einladung widerrufen',
        revokeAction: 'Einladung widerrufen',
        tokenTitle: 'Einladungstoken',
        tokenDescription:
            'Dieser Token wird nur einmal angezeigt. Kopiere ihn jetzt, falls du ihn teilen oder prüfen musst.',
        copyToken: 'Token kopieren',
        tokenCopied: 'Einladungstoken kopiert',
        confirmRevokeTitle: 'Einladung widerrufen',
        confirmRevokeDescription: 'Die Einladung für {{email}} widerrufen?',
        columns: {
            email: 'E-Mail',
            role: 'Rolle',
            status: 'Status',
            expiresAt: 'Läuft ab',
            createdAt: 'Erstellt',
            actions: 'Aktionen',
            actionsDescription: 'Aktionen für diese Einladung, etwa das Widerrufen.'
        },
        roles: {
            owner: 'Eigentümer',
            admin: 'Admin',
            member: 'Mitglied',
            viewer: 'Betrachter'
        },
        statuses: {
            pending: 'Ausstehend',
            accepted: 'Akzeptiert',
            declined: 'Abgelehnt',
            revoked: 'Widerrufen',
            expired: 'Abgelaufen'
        },
        errors: {
            forbidden: 'Du darfst diese Einladungsaktion nicht ausführen.',
            notFound: 'Diese Einladung oder Organisation wurde nicht gefunden.',
            conflict: 'Diese Einladungsaktion verstößt gegen die Zustandsregeln der Einladung.',
            generic: 'Einladungsaktion fehlgeschlagen.'
        }
    },
    organizationInvitationAcceptance: {
        pageTitle: 'Organisationseinladung',
        pageDescription:
            'Prüfe die Einladungsdetails, melde dich falls nötig an und entscheide, ob du der Organisation beitreten möchtest.',
        preparingAuth: 'Authentifizierung wird vorbereitet…',
        resolving: 'Einladung wird geprüft...',
        resolvingDescription: 'Der Einladungstoken wird geprüft und die Einladungsdetails werden geladen.',
        invitationDetailsTitle: 'Einladungsdetails',
        invitationDetailsDescription:
            'Diese Einladung kann nur vom angemeldeten eingeladenen Konto angenommen oder abgelehnt werden.',
        fields: {
            organization: 'Organisation',
            role: 'Rolle',
            email: 'Eingeladene E-Mail',
            status: 'Status'
        },
        unknownOrganization: 'Unbekannte Organisation',
        loginRequiredTitle: 'Anmeldung erforderlich',
        loginRequired: 'Du musst dich anmelden, bevor du auf diese Einladung antworten kannst.',
        loginAction: 'Anmelden, um auf die Einladung zu antworten',
        registerAction: 'Konto erstellen, um auf die Einladung zu antworten',
        acceptAction: 'Einladung annehmen',
        declineAction: 'Einladung ablehnen',
        wrongAccountTitle: 'Falsches Konto angemeldet',
        wrongAccountDescription:
            'Diese Einladung ist für {{invitedEmail}}, aber du bist als {{currentEmail}} angemeldet. Melde dich ab und mit dem eingeladenen Konto wieder an.',
        accepting: 'Einladung wird angenommen...',
        acceptingDescription: 'Wir fügen dich jetzt der Organisation hinzu.',
        declining: 'Einladung wird abgelehnt...',
        decliningDescription: 'Wir lehnen diese Einladung jetzt ab.',
        success: 'Einladung erfolgreich angenommen.',
        declinedSuccess: 'Einladung abgelehnt.',
        declinedSuccessDescription: 'Die Einladung wurde abgelehnt. Du wirst zu deiner Organisation weitergeleitet...',
        redirecting: 'Du wirst zur Organisation weitergeleitet...',
        errorTitle: 'Einladung konnte nicht verarbeitet werden',
        errors: {
            missingToken: 'Im URL fehlt der Einladungstoken.',
            unauthorized: 'Bitte melde dich an und versuche die Einladung erneut.',
            invalidToken: 'Diese Einladung ist ungültig, abgelaufen, abgelehnt, widerrufen oder bereits verwendet.',
            generic: 'Einladungsaktion fehlgeschlagen.'
        }
    },
    organizationApiKeys: {
        pageTitle: 'API-Schlüssel der Organisation',
        pageDescription: 'API-Schlüssel für {{organizationName}} verwalten.',
        fallbackOrganizationName: 'die aktuelle Organisation',
        empty: 'Für diese Organisation wurden keine API-Schlüssel gefunden.',
        permissionHint:
            'Deine aktuelle Organisationsrolle erlaubt das Anzeigen von API-Schlüsseln, aber Erstellen oder Widerrufen ist auf deiner Berechtigungsstufe deaktiviert.',
        subscriptionInactiveDescription:
            'Bestehende API-Schlüssel sind gesperrt und neue API-Schlüssel können erst nach Erneuerung des Abonnements erstellt werden.',
        createAction: 'API-Schlüssel erstellen',
        dialogTitle: 'API-Schlüssel erstellen',
        dialogDescription:
            'Erstelle einen API-Schlüssel für die Organisation und kopiere den Token jetzt — er wird nicht erneut angezeigt.',
        fields: {
            name: 'Name',
            permissions: 'Berechtigungen'
        },
        permissionsDescription: 'Wähle aus, welche Berechtigungen dieser API-Schlüssel verwenden darf.',
        permissionsPublishIncludesRead: 'Publish-Zugriff beinhaltet auch Lesezugriff und wird automatisch hinzugefügt.',
        permissionsInsightsSeparate:
            'Publishing-Berechtigungen beinhalten keinen Insights-Zugriff mehr. Bestehende Schlüssel mit nur Publishing-Berechtigungen können keine Insights lesen - füge die Insights-Leseberechtigung hinzu, wenn ein Schlüssel sie benötigt.',
        permissions: {
            publishing_read: {
                label: 'Publishing-Daten lesen',
                description: 'Erlaubt schreibgeschützten Zugriff auf Publishing-Ressourcen und veröffentlichte Inhalte.'
            },
            publishing_publish: {
                label: 'Medien veröffentlichen',
                description:
                    'Erlaubt das Erstellen von Publishing-Jobs sowie das Hochladen oder Veröffentlichen von Medien.'
            },
            insights_read: {
                label: 'Insights-Daten lesen',
                description: 'Erlaubt schreibgeschützten Zugriff auf Instagram-Insights-Daten.'
            }
        },
        previewAction: 'API-Schlüssel ansehen',
        previewExistingAction: 'Details ansehen',
        backToEdit: 'Zurück zur Bearbeitung',
        previewTitle: 'API-Schlüssel ansehen',
        previewDescription: 'Prüfe die Details und Berechtigungen des API-Schlüssels vor der Erstellung.',
        resultTitle: 'API-Schlüssel erstellt',
        resultDescription:
            'Kopiere und speichere den API-Schlüssel-Token sicher und prüfe dann die gespeicherten Details und Berechtigungen.',
        previewSummaryTitle: 'Vorschau des API-Schlüssels',
        previewSummaryDescription: 'Bestätige Schlüsselnamen und Scopes, bevor der Token erzeugt wird.',
        previewPermissionsDescription: 'Dies sind die Scopes, die dem neuen API-Schlüssel zugewiesen werden.',
        previewExistingTitle: 'Details des API-Schlüssels',
        previewExistingDescription:
            'Prüfe die gespeicherten Metadaten und gewährten Berechtigungen dieses API-Schlüssels.',
        previewExistingLoading: 'Details des API-Schlüssels werden geladen...',
        previewExistingEmpty: 'Für diesen API-Schlüssel wurden keine Details zurückgegeben.',
        previewExistingEndpointUnavailable:
            'Der Endpunkt für die Detailvorschau ist noch nicht verfügbar, daher zeigt dieses Modal die bereits aus der API-Schlüsselliste geladenen Metadaten an.',
        previewExistingPermissionsDescription: 'Dies sind die aktuell diesem API-Schlüssel gewährten Scopes.',
        previewExistingScopesLoaded: 'Berechtigungen wurden vom Detailendpunkt des API-Schlüssels geladen.',
        previewExistingNoScopes: 'Für diesen API-Schlüssel wurden keine Scopes zurückgegeben.',
        previewExistingTokenAvailable: 'Der Token dieses API-Schlüssels kann jetzt angezeigt werden.',
        previewExistingTokenUnavailable:
            'Dieser API-Schlüssel kann angezeigt werden, aber der rohe Tokenwert ist nicht verfügbar.',
        previewExistingLimitation: 'Der Tokenwert ist für diesen API-Schlüssel nicht verfügbar.',
        previewFields: {
            maskedKey: 'Maskierter Schlüssel',
            fullKey: 'Vollständiger API-Schlüssel',
            revokedAt: 'Widerrufen am'
        },
        createSubmit: 'Schlüssel erstellen',
        creating: 'Schlüssel wird erstellt...',
        apiKeyCreated: 'API-Schlüssel erstellt',
        apiKeyRevoked: 'API-Schlüssel widerrufen',
        revokeAction: 'API-Schlüssel widerrufen',
        tokenTitle: 'API-Schlüssel-Token',
        tokenDescription:
            'Kopiere und speichere diesen Token sicher. Er kann in den API-Schlüssel-Details verfügbar bleiben, solange das Backend dies unterstützt.',
        copyToken: 'Token kopieren',
        tokenCopied: 'API-Schlüssel-Token kopiert',
        confirmRevokeTitle: 'API-Schlüssel widerrufen',
        confirmRevokeDescription: 'API-Schlüssel „{{apiKeyName}}“ widerrufen?',
        columns: {
            name: 'Name',
            status: 'Status',
            createdAt: 'Erstellt',
            actions: 'Aktionen',
            actionsDescription: 'Öffnet die Vorschau- oder Detailansicht für diesen Veröffentlichungsjob.'
        },
        statuses: {
            active: 'Aktiv',
            revoked: 'Widerrufen',
            suspended: 'Gesperrt'
        },
        errors: {
            forbidden: 'Du darfst diese API-Schlüssel-Aktion nicht ausführen.',
            notFound: 'Dieser API-Schlüssel oder diese Organisation wurde nicht gefunden.',
            conflict: 'Diese API-Schlüssel-Aktion verstößt gegen die Zustandsregeln des API-Schlüssels.',
            generic: 'API-Schlüssel-Aktion fehlgeschlagen.'
        }
    },
    organizations: {
        loading: {
            title: 'Organisationen werden geladen',
            description: 'Deine Organisationen werden geladen und der aktive Kontext wird ausgewählt.'
        },
        error: {
            title: 'Organisationen konnten nicht geladen werden',
            description: 'Die organisationsbezogene Shell konnte nicht initialisiert werden.',
            fallback: 'Unbekannter Organisationsfehler'
        },
        subscriptionInactive: {
            title: 'Abonnement inaktiv',
            actionBlockedToast: 'Erneuere das Abonnement dieser Organisation, bevor du diese Aktion nutzt.',
            manageBillingAction: 'Abrechnung verwalten',
            ownerHint:
                'Bitte eine Organisationsinhaberin oder einen Organisationsinhaber, die Abrechnung zu erneuern oder zu reaktivieren.'
        },
        limitBanner: {
            cancelEndingTitle: 'Abonnement endet bald',
            cancelEndingDescription:
                'Dieser Workspace verliert am Ende des aktuellen Abrechnungszeitraums den Zugriff. Erneuere oder aktualisiere die Abrechnung, um eine Unterbrechung zu vermeiden.',
            subscriptionInactiveDescription:
                'Für diesen Workspace ist der Abrechnungszugriff inaktiv. Aktualisiere das Abonnement, um den vollen Zugriff wiederherzustellen.',
            trialEndingTitle: 'Testphase endet bald',
            trialEndingDescription:
                'Deine Testphase endet bald. Hinterlege Zahlungsdaten oder upgrade jetzt, um eine Unterbrechung zu vermeiden.',
            manageBillingAction: 'Abrechnung verwalten',
            socialAccountsReachedTitle: 'Limit für Social-Accounts erreicht',
            socialAccountsReachedDescription:
                'Du nutzt {{used}} von {{limit}} verbundenen Social-Account-Slots. Upgrade, um mehr Accounts zu verbinden.',
            upgradeAction: 'Plan upgraden',
            socialAccountsWarningTitle: 'Limit für Social-Accounts fast erreicht',
            socialAccountsWarningDescription:
                'Du nutzt {{used}} von {{limit}} verbundenen Social-Account-Slots. Upgrade, bevor neue Verbindungen blockiert werden.',
            connectedAccountFallback: 'dieses verbundene Konto',
            publishingReachedTitle: 'Veröffentlichungsquote erreicht',
            publishingReachedDescription:
                '{{accountName}} hat alle {{limit}} Posts für den aktuellen Abrechnungszeitraum verbraucht. Upgrade, um weiter zu veröffentlichen.',
            publishingWarningTitle: 'Veröffentlichungsquote fast erreicht',
            publishingWarningDescription:
                '{{accountName}} hat {{currentUsage}} von {{limit}} Posts für den aktuellen Abrechnungszeitraum verbraucht. Upgrade, bevor das Veröffentlichen blockiert wird.'
        },
        fields: {
            name: 'Name der Organisation',
            slug: 'Slug',
            slugHelp: 'Optional. Lass das Feld leer, um automatisch einen Slug aus dem Organisationsnamen zu erzeugen.'
        },
        create: {
            cta: 'Organisation erstellen',
            title: 'Organisation erstellen',
            description: 'Erstelle eine neue Organisation und wechsle sofort zu ihr.',
            pageTitle: 'Neue Organisation',
            pageDescription: 'Erstelle eine neue Organisation und beginne sofort mit ihrer Verwaltung.',
            pageIntro: 'Neue Organisation einrichten',
            pageHint:
                'Nach der Erstellung wird die neue Organisation automatisch zum aktiven Kontext und du wirst zurück in die App geleitet.',
            sectionTitle: 'Weitere Organisation erstellen',
            sectionDescription:
                'Erstelle direkt auf der Seite Organizations eine neue Organisation und mache sie sofort aktiv.',
            hideSection: 'Formular ausblenden',
            submit: 'Erstellen',
            submitting: 'Wird erstellt...',
            success: 'Organisation erstellt',
            error: 'Erstellen der Organisation fehlgeschlagen',
            conflictError: 'Eine Organisation mit diesem Namen oder Slug existiert bereits.',
            validationFallback: 'Bitte korrigiere die Formularfehler und versuche es erneut.'
        },
        switcher: {
            label: 'Organisationen',
            selectOrganization: 'Organisation auswählen',
            loadMore: 'Mehr Organisationen laden ({{shown}}/{{total}})',
            loadError: 'Organisationen konnten nicht geladen werden.',
            emptyTitle: 'Noch keine Organisationen',
            emptyDescription: 'Erstelle deine erste Organisation, um organisationsbezogene Seiten freizuschalten.'
        },
        emptyState: {
            title: 'Erstelle deine erste Organisation',
            description:
                'Du hast noch keine Organisation. Erstelle eine, um den Organisationskontext zu initialisieren und organisationsbezogene Seiten freizuschalten.'
        },
        onboarding: {
            title: 'Organisationen',
            description:
                'Erstelle hier deine erste Organisation. Sobald du eine hast, wird der Rest der App normal verfügbar.',
            createTitle: 'Erstelle deine erste Organisation',
            createDescription:
                'Beginne hier, um den Organisationskontext einzurichten, von dem der Rest des Produkts abhängt.',
            workspaceSetupTitle: 'Organisationseinrichtung abschließen',
            workspaceSetupDescription:
                'Konten ohne Organisationen können weiterhin Organizations und Settings nutzen, damit du die Einrichtung abschließen und dein Profil verwalten kannst.',
            nextStepsTitle: 'Was als Nächstes passiert',
            nextStepsDescription:
                'Sobald die erste Organisation existiert, kann die App mit dem normalen Ablauf fortfahren.',
            nextStepsCreate: 'Erstelle die Organisation, die zu deinem Standardkontext wird.',
            nextStepsInvite:
                'Nach der Erstellung kannst du hierher zurückkehren, um Teammitglieder einzuladen und die Organisation zu erweitern.',
            nextStepsUnlock:
                'Organisationsbezogene Seiten werden automatisch verfügbar, sobald die erste Organisation erstellt wurde.'
        },
        pageShell: {
            title: 'Organisationen',
            description: 'Ein eigener Bereich für Organisationskontext, Erstellung und kommende Verwaltungsfunktionen.',
            overview: {
                title: 'Organisation',
                description:
                    'Überprüfe deine aktuellen Organisationen und wähle den aktiven Kontext für den Rest der App.',
                currentState: 'Aktive Organisation'
            },
            metrics: {
                totalOrganizations: 'Gesamtzahl Organisationen',
                activeOrganization: 'Aktive Organisation',
                activeRole: 'Aktive Rolle',
                noneSelected: 'Nicht ausgewählt'
            },
            list: {
                count: '{{count}} Ergebnisse',
                title: 'Deine Organisationen',
                description:
                    'Sieh dir alle Organisationen an, zu denen du gehörst, und wechsle von hier aus den aktiven Kontext.',
                switchAction: 'Aktivieren',
                membershipIdLabel: 'Mitgliedschafts-ID: {{membershipId}}'
            },
            quickActions: {
                title: 'Schnellaktionen',
                description: 'Starte Organisationsabläufe an einem Ort.',
                hint: 'Diese Seite wird zum zentralen Ziel für Onboarding und Verwaltung von Organisationen.'
            },
            tabs: {
                title: 'Organisationsbereiche',
                description: 'Wechsle zwischen Verwaltungsbereichen der aktiven Organisation.',
                organizations: 'Organisationen',
                members: 'Mitglieder',
                invitations: 'Einladungen',
                membersDescription: 'Verwalte Mitglieder der aktiven Organisation.',
                invitationsDescription: 'Verwalte Einladungen der aktiven Organisation.'
            },
            membersPlaceholder: {
                title: 'Platzhalter für Mitgliederbereich',
                description:
                    'Die Mitgliederverwaltung wird hier erscheinen, sobald die dedizierte Organizations-Seite den aktuellen Mitgliederfluss übernimmt.'
            },
            invitationsPlaceholder: {
                title: 'Platzhalter für Einladungsbereich',
                description:
                    'Die Einladungsverwaltung wird hier erscheinen, sobald die Organizations-Seite den aktuellen Einladungsfluss übernimmt.'
            },
            routingNotice:
                'Mitglieder und Einladungen befinden sich jetzt unter Organizations. API Keys bleiben vorerst separat.'
        }
    },
    confirmDialog: {
        loading: 'Wird geladen...'
    },
    oauthConsent: {
        pageTitle: 'Zugriff autorisieren',
        pageDescription: 'Prüfe diese Anfrage, bevor du Zugriff auf deine Organisationsdaten gewährst.',
        clientRequestTitle: '{{clientName}} fordert Zugriff an',
        clientRequestDescription:
            'Mit deiner Genehmigung darf diese App mit den unten aufgeführten Berechtigungen in deinem Namen handeln.',
        scopesTitle: 'Angeforderte Berechtigungen',
        scopesEmpty: 'Es wurden keine speziellen Berechtigungen angefordert.',
        scopes: {
            mcp: 'Voller MCP-Zugriff',
            mcpDescription: 'Tools für Veröffentlichung und Einblicke über das MCP-Gateway.'
        },
        expiresAt: 'Diese Anfrage läuft am {{date}} ab.',
        organizationTitle: 'Organisation',
        organizationDescription: 'Wähle aus, auf welche Organisation diese App zugreifen darf.',
        organizationSingleDescription: 'Der Zugriff wird für diese Organisation gewährt.',
        organizationsEmptyTitle: 'Keine Organisation verfügbar',
        organizationsEmptyDescription:
            'Du benötigst mindestens eine Organisation, bevor du diese Anfrage genehmigen kannst.',
        approve: 'Genehmigen',
        deny: 'Ablehnen',
        approving: 'Wird genehmigt...',
        denying: 'Wird abgelehnt...',
        redirecting: 'Weiterleitung…',
        redirectsTo: 'Du wirst zu {{url}} weitergeleitet.',
        continueToClient: 'Weiter zu {{host}}',
        redirectBlocked: 'Das Weiterleitungsziel ist nicht erlaubt, daher wurdest du nicht weitergeleitet.',
        errorTitle: 'Diese Anfrage kann nicht abgeschlossen werden',
        errors: {
            missingRequest: 'Die Referenz der Zustimmungsanfrage fehlt in der URL.'
        }
    },

    onboardingFlow: {
        placeholderPreviewTitle: 'Vorschau',
        placeholderPreviewDescription: 'Schrittspezifische Vorschauinhalte werden hier angezeigt.',
        stepPlaceholderDescription:
            'Die Implementierung folgt in den nachgelagerten Schritt-PRs. Dieser Shell-PR verbindet nur Routen, Layout, gemeinsamen Zustand und Navigation.',
        stepBadge: 'Schritt {{step}}',
        saveFailed: 'Dein Onboarding-Fortschritt konnte nicht gespeichert werden. Bitte versuche es erneut.',
        back: 'Zurück',
        continue: 'Weiter',
        next: 'Weiter',
        pricePerMonth: '${{price}}/Monat',
        finish: 'Fertig',
        steps: {
            personalize: 'Personalisieren',
            connect: 'Verbinden',
            activate: 'Aktivieren',
            personalizeLabel: '01 · Personalisieren',
            connectLabel: '02 · Verbinden'
        },
        shell: {
            breadcrumb: 'Einführung',
            help: 'Onboarding-Hilfe öffnen',
            counter: 'Onboarding · {{current}} / {{total}}'
        },
        personalize: {
            title: 'Personalisieren',
            description:
                'Erzähl uns, was du baust, damit wir dein Onboarding und deine Organisationsvoreinstellungen anpassen können.',
            badge: 'Schritt 01 · Personalisieren',
            heroTitle: 'Was baust du?',
            goalsTitle: 'Was möchtest du zuerst tun?',
            goalsLabel: '// wähle deine ziele',
            buildModeTitle: 'Wie möchtest du bauen?',
            buildModeLabel: '// wie du bauen wirst',
            sourcesTitle: 'Wie viele Quellen möchtest du voraussichtlich verbinden?',
            sourcesLabel: '// verbundene quellen',
            sourcesDescription: '2 Quellen sind enthalten. Zusätzliche Quellen kosten $5/Monat pro Stück.',
            sourcesHelper: '2 enthalten, danach je $5/Monat.',
            templatesIncluded: '17 Starter-Templates sind in jedem Plan enthalten',
            decreaseSources: 'Anzahl der Quellen verringern',
            increaseSources: 'Anzahl der Quellen erhöhen',
            goalSingular: 'Ziel',
            goalPlural: 'Ziele',
            summary: '{{goalCount}} {{goalLabel}} · {{mode}} · {{sources}} Quellen · {{price}}/Monat',
            previewEmpty: 'Wähle ein oder mehrere Ziele aus, um die Einrichtungszusammenfassung zu sehen.',
            previewGoals: 'Ausgewählte Ziele',
            previewBuildMode: 'Build-Modus',
            previewSources: 'Angegebene Quellen: {{count}}',
            previewPrice: 'Geschätzter Preis: {{price}}',
            goals: {
                publish: {
                    label: 'Inhalte veröffentlichen',
                    description: 'Inhalte mit minimalem Glue-Code in Kanäle ausspielen.',
                    cardTitle: 'Veröffentlichen & planen',
                    cardDescription: 'Reels, Karussells und Stories — nach deinem Zeitplan',
                    endpointChip: 'POST /v1/publish/post',
                    recipeTitle: 'Content-Planer',
                    recipeDescription:
                        'Reels und Karussells aus deiner eigenen App oder DB in die Warteschlange stellen und automatisch veröffentlichen.'
                },
                comments: {
                    label: 'Kommentare moderieren',
                    description: 'Antworten, Triage und Moderationsabläufe automatisieren.',
                    cardTitle: 'Kommentare & Erwähnungen',
                    cardDescription: 'Konversationen abrufen, sobald sie passieren',
                    endpointChip: 'GET /v1/read/comments',
                    recipeTitle: 'Erwähnungs-Listener',
                    recipeDescription:
                        'Ein Webhook feuert, wenn dich jemand erwähnt — leite ihn an Slack oder dein CRM weiter.'
                },
                analytics: {
                    label: 'Analysen lesen',
                    description: 'Konto- und Inhaltsmetriken in deine App holen.',
                    cardTitle: 'Analysen & Insights',
                    cardDescription: 'Reichweite, Wachstum und beste Veröffentlichungszeit',
                    endpointChip: 'GET /v1/read/analytics',
                    recipeTitle: 'Analyse-Dashboard',
                    recipeDescription:
                        'Reichweiten-, Wachstums- und Best-Time-Metriken werden für dich berechnet und in deine DB geschrieben.'
                },
                ai: {
                    label: 'KI-Agenten ausliefern',
                    description: 'Content-Tools mit agentengesteuerten Workflows kombinieren.',
                    cardTitle: 'KI-Kommentarantworten',
                    cardDescription: 'Antworten in deinem Ton entwerfen — freigeben oder automatisch senden',
                    endpointChip: 'MCP · Antwort-Tools',
                    recipeTitle: 'Kommentarantwort-Assistent',
                    recipeDescription:
                        'Ein KI-Agent entwirft Antworten in deiner Markenstimme; du gibst sie frei oder sendest automatisch.'
                },
                ugc: {
                    label: 'UGC verwalten',
                    description: 'Creator-Content mit Freigaben sammeln und weiterleiten.',
                    cardTitle: 'UGC erneut posten',
                    cardDescription: 'Markierte Inhalte finden und erneut veröffentlichen',
                    endpointChip: 'GET /v1/read/mentions',
                    recipeTitle: 'UGC-Repost-Tool',
                    recipeDescription:
                        'Markierte Beiträge finden, Rechte anfragen und reposten — die ganze Schleife automatisiert.'
                },
                webhooks: {
                    label: 'Webhooks empfangen',
                    description: 'Auf Konto- und Veröffentlichungsereignisse reagieren.',
                    cardTitle: 'Webhooks & Ereignisse',
                    cardDescription: 'Signierte Webhooks für Kommentare, Erwähnungen und DMs',
                    endpointChip: 'POST /v1/webhooks',
                    recipeTitle: 'Event-Relay',
                    recipeDescription:
                        'Signierte, wiederholte Webhooks für jeden Kommentar, jede Erwähnung und jede DM.'
                }
            },
            buildModes: {
                code: {
                    label: 'Code schreiben',
                    description: 'Ich möchte volle API-Kontrolle und direkte Implementierung.',
                    summary: 'REST-API & SDKs'
                },
                agent: {
                    label: 'Mit einem KI-Agenten',
                    description: 'Ein Agent soll beim Verdrahten und Automatisieren helfen.',
                    summary: 'MCP für Claude & Cursor'
                },
                both: {
                    label: 'Beides',
                    description: 'Code-zuerst-Kontrolle mit Agentenhilfe, wenn sinnvoll.',
                    summary: 'Code + Agenten'
                }
            }
        },
        connect: {
            title: 'Instagram verbinden',
            description:
                'Verbinde jetzt mindestens ein professionelles Instagram-Konto oder überspringe es und gehe direkt zum Test-Checkout.',
            badge: 'Schritt 02 · Verbinden',
            headingTitle: 'Verbinden',
            headingEmphasis: 'Instagram verbinden.',
            headingRest: 'Jetzt ein professionelles Konto oder direkt zum Checkout springen.',
            requirementsLabel: '// voraussetzungen',
            afterTrial: '/Monat nach der Testphase',
            trialBadge: '7-tägige Testphase',
            completedBadge: 'Checkout abgeschlossen',
            connectLaterBadge: 'Später verbinden',
            priceStripBreakdown: '{{sources}} Quellen · 2 in der $9-Basis enthalten',
            priceStripTerms: '7 Tage Testphase · Karte an Tag 0 · erste Abbuchung an Tag 8',
            skip: 'Vorerst überspringen — direkt zum Test-Checkout',
            trust: {
                secureTitle: 'Nur sicheres OAuth',
                secureDescription:
                    'Wir fragen nie nach deinem Instagram-Passwort. Du autorisierst den Zugriff direkt bei Meta.',
                setupTitle: 'Bereit zum Veröffentlichen',
                setupDescription:
                    'Wir verwenden diese Verbindung, um Planung, Veröffentlichung und Analysen für deine Organisation vorzubereiten.',
                laterTitle: 'Du kannst später mehr hinzufügen',
                laterDescription: 'Verbinde jetzt ein Konto und füge später weitere hinzu, wenn dein Team bereit ist.'
            },
            requirementsTitle: 'Voraussetzungen vor dem Verbinden',
            requirements: {
                professional: 'Dein Instagram-Konto muss ein professionelles Business- oder Creator-Konto sein.',
                page: 'Dieses Instagram-Konto muss bereits mit einer Facebook-Seite verknüpft sein.'
            },
            connectionTitle: 'Instagram-Verbindung',
            connectionDescription:
                'Autorisiere Instagram über Meta – du wirst weitergeleitet und direkt hierher zurückgebracht.',
            connectedCounter: 'verbunden: {{connected}} / {{sources}}',
            declaredSources: 'Angegebene Quellen: {{count}}',
            connected: 'Verbunden: {{count}}',
            syncedSources: 'Synchronisierte Quellen: {{count}}',
            errorTitle: 'Verbindung fehlgeschlagen',
            errors: {
                callbackFailed: 'Die Verbindung deines Instagram-Kontos ist fehlgeschlagen. Bitte versuche es erneut.',
                popupBlocked: 'Das Instagram-Login-Popup wurde blockiert. Aktiviere Popups und versuche es erneut.',
                oauthDenied: 'Die Instagram-Autorisierung wurde abgebrochen, bevor Berechtigungen erteilt wurden.',
                personalAccount:
                    'Es werden nur professionelle Instagram-Konten unterstützt. Stelle dieses Konto zuerst auf Business oder Creator um.',
                missingPage:
                    'Dieses Instagram-Konto muss mit einer Facebook-Seite verbunden sein, bevor es hier verwendet werden kann.'
            },
            ctaConnect: 'Instagram-Konto verbinden',
            ctaConnectAnother: 'Weiteres Konto verbinden',
            ctaConnectShort: 'Konto verbinden',
            ctaConnected: 'Verbunden',
            ctaWaiting: 'Warte auf Instagram…',
            previewTitle: 'Verbundene Konten',
            previewDescription: 'Die Anzahl verbundener Konten kann die Quellanzahl automatisch erhöhen.',
            previewSourcesNow: 'Quellen jetzt: {{count}}',
            previewEmptyTitle: 'Noch keine Instagram-Konten verbunden',
            previewEmptyDescription: 'Verbinde links ein Konto, um zu sehen, wie sich dein Onboarding ausfüllt.',
            previewNextStep: 'Nächster Schritt',
            previewActivate: 'Kostenlose Testphase aktivieren',
            previewRequirementsLink: 'Instagram-Voraussetzungen ansehen',
            previewSyncedMessage:
                'Der gemeinsame Zustand synchronisiert Quellen nach oben. Aktuell angegebene Quellen: {{count}}',
            checkoutCanceled: 'Checkout wurde abgebrochen. Dein Onboarding-Status ist noch da.',
            checkoutUnavailable:
                'Der Checkout ist noch nicht verfügbar – es ist kein Abrechnungsprodukt konfiguriert. Bitte versuche es später erneut.',
            finalizingTitle: 'Dein Abo wird abgeschlossen',
            finalizingDescription:
                'Wir warten auf die Bestätigung deines Checkouts durch Stripe. Das dauert normalerweise nur wenige Sekunden.',
            checkoutTitle: 'Preise für die Testphase',
            checkoutDescription: 'Es gibt keinen separaten Schritt 3 mehr — der Checkout startet direkt hier.',
            checkoutCta: '{{days}}-tägige Testphase starten',
            nextToDashboard: 'Zum Dashboard-Willkommenszustand',
            previewConnectLater: 'Falls nötig, später im Dashboard verbinden.',
            previewTrialDetailsTitle: 'Details zur Testphase',
            previewTrialDetails:
                'Tag 0: Karte erfasst. Tag 8: erste Abbuchung. Erfolg leitet in den Dashboard-Willkommenszustand weiter.'
        },
        activate: {
            title: 'Organisation aktivieren',
            description:
                'Starte deine Testphase, bestätige die Anzahl der Quellen und übergib die Einrichtung an den Dashboard-Willkommenszustand.',
            trialActivatedTitle: 'Testphase aktiviert',
            trialActivatedDescription:
                'Deine Organisation ist bereit. Der Dashboard-Willkommenszustand sollte deine Ziele, den Verbindungsstatus und den {{count}}-Quellen-Plan übernehmen.',
            waitingCards: {
                connectionTitle: 'Instagram-Verbindung',
                connectionDescription:
                    'Wenn du das Verbinden übersprungen hast, kannst du es später im Dashboard abschließen.',
                workspaceTitle: 'Letzte Organisationsschritte',
                workspaceDescription:
                    'Deine Quellen, Ziele und Aktivierungszusammenfassung werden in den Dashboard-Willkommenszustand übernommen.'
            },
            nextToDashboard: 'Zum Dashboard-Willkommenszustand',
            startTrial: '{{days}}-tägige Testphase starten',
            cancelBannerTitle: 'Checkout abgebrochen',
            cancelBannerDescription:
                'Deine Testphase wurde nicht gestartet. Alles, was du hier eingerichtet hast, bleibt erhalten.',
            badge: 'Schritt 3 · Aktivieren',
            heroTitle: 'Deine {{days}}-tägige Testphase aktivieren',
            heroDescription:
                'Noch keine echte Abrechnung. Dies ist ein gemockter Stripe-Handoff, der deinen Onboarding-Zustand über Weiterleitung, Abbruch und Erfolg hinweg erhält.',
            postTrialPrice: 'Preis nach der Testphase',
            chargedStarting: 'Ab Tag {{day}} berechnet',
            trust: {
                startToday: 'Starte heute deine {{days}}-tägige Testphase',
                cardRequired: 'Karte erforderlich, um deine Organisation zu aktivieren',
                noCharge: 'Dir wird erst ab Tag {{day}} etwas berechnet'
            },
            priceBreakdownTitle: 'Preisaufschlüsselung',
            priceBreakdownDescription:
                'Passe die Quellen vor dem Start der Testphase inline an. Die Preislogik bleibt an den gemeinsamen Helper gebunden.',
            sourcesTitle: 'Quellen',
            sourcesDescription: 'Verwende für dieses Setup mindestens {{count}} Quellen.',
            baseLabel: 'Basis ({{count}} Quellen)',
            baseDetail: 'Vor Add-ons enthalten',
            additionalLabel: 'Zusätzliche Quellen',
            additionalDetailNone: 'Keine zusätzlichen Quellen ausgewählt',
            additionalDetailSome: '{{count}} × ${{price}}',
            monthlyAfterTrialLabel: 'Monatlich nach der Testphase',
            monthlyAfterTrialDetail: 'Exakter Preis nach der Testphase',
            breakdownIncluded: '{{count}} Quellen sind im Basispreis von ${{price}} enthalten',
            breakdownExpanded: '${{base}} Basis + {{extraCount}} × ${{extraPrice}}',
            stripeHandoffTitle: 'Gemockter Stripe-Handoff',
            stripeHandoffDescription:
                'Nutze die gemockten Zustände unten, um Weiterleitung, Abbruch und Erfolg ohne echte Abrechnung zu prüfen.',
            stripeReady: 'Bereit zum Start',
            stripeRedirecting: 'Weiterleitung zu Stripe…',
            redirectTitle: 'Weiterleitung zu Stripe Checkout',
            redirectDescription:
                'In Produktion würde Stripe hier die Karte erfassen und zur App zurückleiten. Wähle vorerst das gemockte Ergebnis.',
            simulateCancel: 'Abbruch simulieren',
            simulateSuccess: 'Erfolgreichen Checkout simulieren',
            stripeCtaNote:
                'Die CTA startet eine gemockte Stripe-Sitzung und behält deinen Onboarding-Zustand über den Rückweg bei.',
            recapTitle: 'Einrichtungsübersicht',
            recapHeading: 'Bereit zur Aktivierung',
            recapGoals: 'Ausgewählte Ziele',
            recapInstagram: 'Instagram',
            recapSources: 'Quellen',
            recapTrialDetails: 'Details zur Testphase',
            recapAfterCheckout: 'Nach dem Checkout',
            recapNoneYet: 'Noch keine',
            recapConnected: '{{count}} verbunden',
            recapSkipped: 'Noch nicht — vorerst übersprungen',
            recapNotConnected: 'Noch nicht verbunden',
            recapSourcesValue: '{{count}} Quellen · {{price}} nach der Testphase',
            recapTrialValue: '{{days}} Tage kostenlos · Karte erforderlich · keine Belastung bis Tag {{day}}',
            recapAfterCheckoutPending:
                'Der Dashboard-Willkommenszustand erhält diese Zusammenfassung nach erfolgreichem Checkout.',
            recapAfterCheckoutComplete:
                'Leite den Nutzer mit dieser Zusammenfassung in den Dashboard-Willkommenszustand.',
            expectedPriceTitle: 'Erwarteter monatlicher Preis nach der Testphase'
        }
    },
    pricing: {
        pageTitle: 'Preise',
        pageDescription: 'Klare quellbasierte Preise, die zum restlichen App-Erlebnis passen.',
        eyebrow: 'Preise',
        calculatorTitle: 'Preis berechnen',
        calculatorDescription:
            'Wähle aus, wie viele Quellen du brauchst, und der monatliche Gesamtpreis wird sofort aktualisiert.',
        accountsLabel: 'Quellen',
        accountsIncludedLabel: 'In deinem Plan enthaltene Quellen',
        minAccounts: '{{count}} Quelle',
        maxAccounts: '{{count}} Quellen',
        firstTierLabel: 'Erste {{count}} Quellen',
        firstTierRate: '{{price}} für {{count}} Quellen',
        additionalAccountsLabel: 'Zusätzliche Quellen',
        additionalAccountsRate: '{{price}} pro zusätzlicher Quelle',
        monthlyTotalLabel: 'Monatlicher Gesamtpreis',
        monthlyOnlyHint: 'Live-Schätzung, monatlich abgerechnet',
        customSolutionTitle: 'Brauchst du eine individuelle Lösung?',
        customSolutionDescription:
            'Sprich mit uns, wenn du Preise für größere Volumen oder Hilfe beim Onboarding brauchst.',
        trialTitle: '7-tägige Testphase',
        trialDescription:
            'Starte mit einer 7-tägigen Testphase und nutze danach denselben monatlichen mengenbasierten Plan weiter.',
        checkoutCta: 'Testphase in Stripe starten',
        requiresOrganization: 'Erstelle oder wähle eine Organisation aus, bevor du den Checkout startest.',
        checkoutForOrganization: 'Der Checkout startet für {{organizationName}} mit der ausgewählten Menge.',
        manageSubscriptionCta: 'Abonnement verwalten',
        alreadySubscribed:
            '{{organizationName}} hat bereits ein aktives Abonnement. Ändere die Anzahl der Quellen in den Einstellungen.',
        contactCta: 'Kontaktiere uns',
        planTitle: 'Dein Plan',
        planDescription:
            'Transparente monatliche Preise mit {{count}} enthaltenen Quellen, danach ein fester Aufpreis pro zusätzlicher Quelle.',
        month: 'Monat',
        accountsSelected: '{{count}} Quellen ausgewählt',
        planFirstTierLine: 'Erste {{count}} Quellen enthalten',
        planTierCalculation: '{{price}} × {{count}}',
        includedLabel: 'Enthalten',
        primaryCta: 'Loslegen',
        monthlyOnlyDisclaimer: 'Nur monatliche Preise. Keine Credits und keine Annahmen zur jährlichen Abrechnung.',
        features: {
            organizations: 'Organisationen, Mitglieder und Einladungen',
            socialAccounts: 'Verbundene Social-Media-Konten',
            publishing: 'Workflows zum Veröffentlichen von Beiträgen',
            insights: 'Instagram-Einblicke',
            apiKeys: 'API-Schlüssel der Organisation',
            customerSupport: 'Kundensupport'
        }
    },
    apiErrors: {
        auth: {
            required: 'Authentifizierung ist erforderlich.',
            invalidOrExpiredToken:
                'Authentifizierung ist erforderlich. Deine Sitzung ist möglicherweise ungültig oder abgelaufen.'
        },
        validation: {
            invalidRequestBody:
                'Die Anfrage ist ungültig. Bitte überprüfe die übermittelten Daten und versuche es erneut.',
            required: 'Dieses Feld ist erforderlich.',
            emailInvalid: 'Bitte gib eine gültige E-Mail-Adresse ein.',
            stringMaxLength: 'Dieser Wert ist zu lang.'
        },
        organizations: {
            invalidRequest: 'Die Organisationsanfrage ist ungültig.',
            conflict: 'Eine Organisation mit diesen Daten existiert bereits.',
            notFound: 'Die Organisation wurde nicht gefunden.',
            loadFailed: 'Organisationen konnten nicht geladen werden.',
            createFailed: 'Die Organisation konnte nicht erstellt werden.',
            validation: {
                nameMaxLength: 'Der Organisationsname ist zu lang.',
                slugMaxLength: 'Der Organisations-Slug ist zu lang.',
                slugFormat: 'Der Organisations-Slug darf nur Kleinbuchstaben, Zahlen und Bindestriche enthalten.'
            }
        },
        onboarding: {
            updateForbidden: 'Nur Organisationsinhaber und Admins können das Onboarding aktualisieren.',
            validation: {
                goalsRequiredBeforeConnect: 'Wähle mindestens ein Onboarding-Ziel aus, bevor du fortfährst.'
            }
        },
        billing: {
            invalidRequest: 'Die Abrechnungsanfrage ist ungültig.',
            manageForbidden: 'Du darfst die Abrechnung für diese Organisation nicht verwalten.',
            organizationNotFound: 'Die Organisation wurde nicht gefunden.',
            organizationOrProductNotFound: 'Die Organisation oder das Abrechnungsprodukt wurde nicht gefunden.',
            incompleteConfiguration:
                'Die Abrechnung ist für diesen Checkout-Ablauf noch nicht vollständig konfiguriert.',
            lifetimeSubscriptionActive:
                'Diese Organisation nutzt einen Lifetime-Plan, daher ist die Stripe-Abrechnung nicht verfügbar. Wende dich an invisibleapi, um den Plan zu ändern.',
            integration: 'Der Abrechnungsanbieter hat einen Integrationsfehler zurückgegeben.',
            productsLoadFailed: 'Abrechnungspläne konnten nicht geladen werden.',
            stateLoadFailed: 'Der Abrechnungsstatus der Organisation konnte nicht geladen werden.',
            checkoutFailed: 'Die Checkout-Sitzung konnte nicht erstellt werden.',
            customerPortalFailed: 'Das Kundenportal konnte nicht geöffnet werden.',
            validation: {
                successUrlInvalid: 'Die Erfolgs-URL der Abrechnung ist ungültig.',
                cancelUrlInvalid: 'Die Abbruch-URL der Abrechnung ist ungültig.',
                returnUrlInvalid: 'Die Rückkehr-URL der Abrechnung ist ungültig.'
            }
        },
        userProfile: {
            loadFailed: 'Kontodetails konnten nicht geladen werden.',
            updateFailed: 'Kontodetails konnten nicht gespeichert werden.',
            actionEmailFailed: 'Die Sicherheits-E-Mail für das Konto konnte nicht angefordert werden.',
            accountServiceUnavailable: 'Der Kontodienst konnte die Anfrage momentan nicht abschließen.',
            notFound: 'Das Kontoprofil wurde nicht gefunden.',
            updateRejected: 'Der Kontodienst hat die Aktualisierung der Kontodetails abgelehnt.',
            actionRejected: 'Der Kontodienst hat die Sicherheits-E-Mail-Anfrage abgelehnt.',
            validation: {
                readOnly: 'Dieses Feld ist schreibgeschützt.',
                unsupported: 'Dieses Feld wird nicht unterstützt.'
            }
        },
        organizationInvitations: {
            listForbidden: 'Du darfst Einladungen für diese Organisation nicht ansehen.',
            createForbidden: 'Du darfst keine Mitglieder in diese Organisation einladen.',
            revokeForbidden: 'Du darfst Einladungen für diese Organisation nicht widerrufen.',
            createConflict:
                'Diese Einladung kann nicht erstellt werden, weil sie gegen Organisationsregeln für Einladungen verstößt.',
            revokeConflict: 'Diese Einladung kann aufgrund ihres aktuellen Status nicht widerrufen werden.',
            notFound: 'Die Organisation oder Einladung wurde nicht gefunden.',
            invalidToken: 'Diese Einladung ist ungültig, abgelaufen, widerrufen oder bereits verwendet.',
            actionFailed: 'Die Einladungsaktion konnte nicht abgeschlossen werden.'
        },
        organizationMembers: {
            listForbidden: 'Du darfst Mitglieder dieser Organisation nicht ansehen.',
            removeForbidden: 'Du darfst dieses Mitglied nicht entfernen.',
            removeConflict:
                'Dieses Mitglied kann nicht entfernt werden, weil dies gegen die Regeln der Organisationsmitgliedschaft verstößt.',
            updateForbidden: 'Du darfst dieses Mitglied nicht aktualisieren.',
            updateConflict: 'Diese Rollenänderung verstößt gegen die Regeln der Organisationsmitgliedschaft.',
            actionFailed: 'Die Mitgliederaktion konnte nicht abgeschlossen werden.',
            validation: {
                roleInvalid: 'Die ausgewählte Organisationsrolle ist ungültig.'
            }
        },
        organizationApiKeys: {
            listForbidden: 'Du darfst API-Schlüssel dieser Organisation nicht ansehen.',
            manageForbidden: 'Du darfst API-Schlüssel für diese Organisation nicht verwalten.',
            notFound: 'Die Organisation oder der API-Schlüssel wurde nicht gefunden.',
            createConflict:
                'Dieser API-Schlüssel kann nicht erstellt werden, weil er gegen die Regeln für API-Schlüssel der Organisation verstößt.',
            revokeConflict: 'Dieser API-Schlüssel kann aufgrund seines aktuellen Status nicht widerrufen werden.',
            actionFailed: 'Die API-Schlüssel-Aktion konnte nicht abgeschlossen werden.',
            validation: {
                nameMaxLength: 'Der Name des API-Schlüssels ist zu lang.'
            }
        },
        socialAccounts: {
            listFailed: 'Social-Media-Konten konnten nicht geladen werden.',
            connectFailed: 'Die Verbindung des Social-Media-Kontos konnte nicht gestartet werden.',
            reconnectFailed: 'Der erneute Verbindungsablauf des Social-Media-Kontos konnte nicht gestartet werden.',
            disconnectFailed: 'Das Social-Media-Konto konnte nicht getrennt werden.',
            forbidden: 'Du darfst Social-Media-Konten für diese Organisation nicht verwalten.',
            notFound: 'Die Organisation oder das Social-Media-Konto wurde nicht gefunden.',
            conflict:
                'Diese Social-Media-Konto-Aktion konnte aufgrund ihres aktuellen Status nicht abgeschlossen werden.'
        },
        publishing: {
            listFailed: 'Veröffentlichungsaufträge konnten nicht geladen werden.',
            detailFailed: 'Die Details des Veröffentlichungsauftrags konnten nicht geladen werden.',
            createFailed: 'Der Veröffentlichungsauftrag konnte nicht erstellt werden.',
            paidPlanLimitExceeded: 'Ein Veröffentlichungslimit des kostenpflichtigen Plans wurde erreicht.',
            paidPlanLimitExceededForAccount: 'Veröffentlichungslimit für {{account}} erreicht.',
            paidPlanLimitExceededUnknownAccount: 'das ausgewählte Konto',
            paidPlanLimitExceededUsageDetails:
                'Aktuelle Nutzung: {{currentUsage}}/{{limit}}. Aktive Reservierungen: {{activeReservations}}. Angeforderte Beiträge: {{requestedCount}}.',
            paidPlanLimitExceededResetDetails: 'Versuche es nach {{resetAt}} erneut.',
            forbidden: 'Du darfst Veröffentlichungen für diese Organisation nicht verwalten.',
            notFound: 'Die Organisation oder der Veröffentlichungsauftrag wurde nicht gefunden.',
            conflict:
                'Diese Veröffentlichungsanfrage konnte aufgrund aktueller Veröffentlichungseinschränkungen nicht abgeschlossen werden.',
            validation: {
                mediaUrlUnreachable:
                    'Die Medien-URL ist nicht erreichbar. Gib einen öffentlich zugänglichen, direkten Link zu einer Mediendatei an.',
                mediaUrlHttpError:
                    'Die Medien-URL hat mit einem Fehler geantwortet, statt eine Mediendatei zu liefern.',
                mediaUrlNotImage:
                    'Diese URL verweist nicht auf eine Bilddatei. Verlinke direkt auf ein Bild (z. B. eine .jpg-URL), nicht auf eine Webseite.',
                mediaUrlNotVideo:
                    'Diese URL verweist nicht auf eine Videodatei. Verlinke direkt auf ein Video (z. B. eine .mp4-URL), nicht auf eine Webseite.'
            }
        },
        oauthConsent: {
            loadFailed: 'Die Zustimmungsanfrage konnte nicht geladen werden.',
            approveFailed: 'Die Zustimmungsanfrage konnte nicht genehmigt werden.',
            denyFailed: 'Die Zustimmungsanfrage konnte nicht abgelehnt werden.',
            invalidRequest: 'Die Zustimmungsanfrage ist ungültig.',
            forbidden: 'Du darfst diese Anfrage für die ausgewählte Organisation nicht genehmigen.',
            notFound: 'Diese Zustimmungsanfrage ist unbekannt, abgelaufen oder wurde bereits bearbeitet.'
        },
        insights: {
            loadFailed: 'Einblicke konnten nicht geladen werden.',
            invalidQuery:
                'Die Einblicke-Abfrage ist ungültig. Prüfe die Kombination aus Metrik, Periode und Parametern.',
            forbidden: 'Du darfst die Einblicke dieser Organisation nicht ansehen.',
            notFound: 'Die Organisation oder das soziale Konto wurde nicht gefunden.',
            notReadable:
                'Dieses Konto kann derzeit keine Einblicke liefern. Verbinde es mit der Einblicke-Berechtigung neu.',
            providerRejected:
                'Instagram hat diese Einblicke-Anfrage abgelehnt. Die angeforderte Metrik-Kombination wird für dieses Konto möglicherweise nicht unterstützt.'
        }
    },
    validation: {}
} as const;
